module.exports = __webpack_public_path__ + "static/media/insurance.d8be1211.jpg";